import { Action } from 'redux';
import { ErrorWrapper } from 'store/base';

export const REDUCER_KEY__SHIPPING_ORDER = 'shippingOrder';

export class ShippingOrderState {
  type?: string;
  errorWrapper?: ErrorWrapper;
  shippingOrderId?: string;
  loading: boolean;
}

const defaultState: ShippingOrderState = {
  loading: false,
};
export default (state: ShippingOrderState = defaultState, action: Action): ShippingOrderState => {
  return state;
};
